import {
    Show,
    ShowProps,
    SimpleShowLayout,
    TextField,
    NumberField,
    ImageField
} from 'react-admin';
import React from 'react';

const CategoryShow = (props: ShowProps) => (
    <Show {...props}>
        <SimpleShowLayout>
            <TextField source="id" />
            <TextField source="name_en" />
            <TextField source="name_ar" />
            <ImageField source="featured_image" /> 
            <TextField source="is_featured" />          
        </SimpleShowLayout>
    </Show>
)

export default CategoryShow;